const statusAssets = {
  active: {
    id: 1,
    description: 'assetActive',
  },
  inactive: {
    id: 2,
    description: 'assetInactive',
  },
};

export { statusAssets };
